window._define('widgets/tagsSelect', ['jquery', '_', 'widgets/baseWidget'], function ($, _, BaseWidget) { 'use strict';
    var template = _.template;

    if (!BaseWidget) {
        return null;
    }

    // widget definition
    $.widget('OC.tagsSelect', BaseWidget, {

        options: {
            ajaxify: true,
            tagClassName: 'orange',
            dataUrl: null,
            data: null,
            jsonValue: false,
            dataMap: null,
        },

        _create: function () {
            var self = this;

            this._super();
            this.items = [];

            this.elements.$shadowInput = $('input[type=search], input[type=text]', this.element);

            this.elements.$displayedInput = $('<input>')
                .attr('type', 'text')
                .removeAttr('name id')
                .insertAfter(this.elements.$shadowInput);

            this.elements.$shadowInput
                .removeClass()
                .css({
                    position: 'absolute',
                    zIndex: -1,
                });

            if (!this.options.dataUrl) {
                this._addAutocompleteElement(this.options.source);
            } else {
                this._getData(this.options.dataUrl, function (source) {
                    self._addAutocompleteElement(source);
                });
            }

        },

        _dataMap: function (sourceObj, map) {
            var out = {};

            $.each(map, function (key, value) {
                out[key] = sourceObj[value];
            });

            return out;
        },

        _getData: function (url, callback) {
            var self = this,
                toggleloading = function (state) {
                    self.element.closest('form').toggleClass('loading', state);
                };

            toggleloading(true);

            $.getJSON(url, function (data) {
                // remap data in order to be compliant
                data = _.map(data, function (value, index) {
                    return {
                        label: value,
                        value: index,
                    };
                });
                callback(data);
            })
                .always(function () {
                    toggleloading(false);
                });
        },

        _addAutocompleteElement: function (source) {
            var value = this.elements.$shadowInput.val(),
                self = this;

            this.elements.$displayedInput
                .autocompletefield({
                    dataMap: this.options.dataMap,
                    source: source, //this.options.source,
                    itemTemplate: this.options.itemTemplate,
                    select: function (event, ui) {
                        self.addItem(ui.item);
                        this.value = '';
                        return false;
                    },
                })
                .on('blur focus', function (event) {
                    self.element.toggleClass('focus', (event.type === 'focus'));

                    // reset value
                    if (event.type === 'blur') {
                        $(this).val('');
                    }
                });

            this._attachEvents();

            // data in input value
            if (value && !this.options.data) {
                // try to parse json values
                try {
                    this.options.data = JSON.parse(value);
                    this.elements.$displayedInput.val('');
                } catch (e) {
                    //
                }
            }

            // handle default data
            if (this.options.data) {

                // {'1':'test'} format detected
                if (!$.isArray(this.options.data) /*&& _(obj).size() === 1*/) {
                    // this.options.data = [this.options.data];
                    this.options.data = _.map(this.options.data, function (value, index) {
                        return {
                            label: value,
                            value: index,
                        };
                    });
                }

                this.addItem(this.options.data, false);
            }

        },

        _updateRealValue: function () {
            var newItems = {},
                items = this.items,
                $input = this.elements.$shadowInput;

            if (this.options.jsonValue) {
                $.each(items, function (key, item) {
                    newItems[item.value] = item.label;
                });

                $input.val(JSON.stringify(newItems));
            } else {
                $input.val(
                    _.map(items, 'value')
                        .join(',')
                );

            }

        },

        _getTagElement: function (item) {
            var self = this,
                tpl, dismiss;

            if (!this._tplTag) {
                tpl  = '<span class="input-group-button">';
                tpl += '    <span class="label">';
                tpl += '    <% if (typeof icon !== "undefined") { %>';
                tpl += '        <span class="label__thumbnail" style="background-image: url(\'<%= icon %>\')"></span>';
                tpl += '    <% } %>';
                tpl += '        <span class="label__text"><%= label %></span>';
                tpl += '        <a class="label__closeButton js-close-button">×</a>';
                tpl += '    </span>';
                tpl += '</span>';

                this._tplTag = template(tpl);
            }

            dismiss = $(this._tplTag(item))
                .dismissibleElement({
                    data: item,
                    callback: function () {
                        self.removeItem(this.data);
                    },
                });

            $('.label', dismiss)
                .addClass(this.options.tagClassName);

            return dismiss;
        },

        _getItem: function (item) {
            return _.find(this.items, { value: item.value });
        },

        removeItem: function (item, triggerEvent) {
            if (typeof triggerEvent !== 'boolean') {
                triggerEvent = true;
            }

            _.remove(this.items, { value: item.value });

            this._updateRealValue(triggerEvent);

            if (triggerEvent) {
                this._trigger('change');
            }

        },

        getItems: function () {
            return this.items;
        },

        addItem: function (item, triggerEvent) {
            var elem,
                existingItem,
                hasChanged = false,
                self = this,
                items = $.isArray(item) ? item : [item];

            if (typeof triggerEvent !== 'boolean') {
                triggerEvent = true;
            }

            items.forEach(function (i) {
                var item = self.options.dataMap ? self._dataMap(i, self.options.dataMap) : i;

                existingItem = self._getItem(item);

                if (!existingItem) {
                    self.items.push(item);

                    elem = $(self._getTagElement(item))
                        // not so reliable, I think the helper is not something definitive in jQuery UI...
                        .insertBefore($('.ui-autocomplete-input', self.element));

                    item.$elem = $(elem);

                    hasChanged = true;

                } else {
                    // pulsate existing tag
                    existingItem.$elem
                        .animate({ opacity: 0 }, 200)
                        .animate({ opacity: 1 }, 200);
                }

            });

            if (hasChanged) {
                self._updateRealValue(triggerEvent);

                if (triggerEvent) {
                    self._trigger('change');
                }
            }

        },

        //        disable: function () {
        //            this._super();
        //            console.log('disable');
        //        },
        //
        //        enable: function () {
        //            this._super();
        //        },

        val: function () {
            return this.elements.$shadowInput.val();
        },

        _attachEvents: function () {
            this.element
                // don't navigate away from the field on tab when selecting an item
                .on('keydown', 'input[type=search]', function (event) {
                    if (event.keyCode === $.ui.keyCode.TAB && $(this).data('OC-autocompletefield').menu.element.is(':visible')) {
                        event.preventDefault();
                    }
                });
        },
    });

    // FIXME: not a good idea...
    // bind on domready for automatic instantiation
    $(document).ready(function () {
        $('.js-tags-select').tagsSelect();
    });

    return $.OC.tagsSelect;

});
